var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.66515L12.94 12.7751H15.76L13.49 14.3951L14.42 17.4051L12 15.5651L9.58 17.4051L10.51 14.3951L8.24 12.7751H11.06L12 9.66515ZM12 2.77515L9.58 10.7751H2L8.17 15.1851L5.83 22.7751L12 18.0851L18.18 22.7751L15.83 15.1851L22 10.7751H14.42L12 2.77515Z",
    fill: "#393941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRateIcon);
export default __webpack_public_path__ + "static/media/star_rate_icon.7fffc69c.svg";
export { ForwardRef as ReactComponent };